export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LogsActividad.vue?vue&type=template&id=0b5e1ce8&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/SystemManagement/logs-management/LogsActividad.vue?vue&type=template&id=0b5e1ce8&
// module id = null
// module chunks = 